import { useEffect, useState } from "react";
import { getAuth, createUserWithEmailAndPassword, onAuthStateChanged, signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../service";
import { Link, useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Card } from "react-bootstrap";
import { useSetRecoilState } from 'recoil';
import { loggedUser } from '../../state/atom';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function LoginPageDisplay() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [authing, setAuthing] = useState(false);
    const navigate = useNavigate();
    const setUser = useSetRecoilState(loggedUser);

    function handleLogin() {
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                alert(`Usuário logado com sucesso, bem-vindo(a)!`)
                navigate('/minhas-listas');
                // ...
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                // ..
            });

    }
    async function signInWithGoogle() {
        setAuthing(true);

        signInWithPopup(auth, new GoogleAuthProvider())
            .then(res => {
                let userRegister = {
                    uid: res.user.uid,
                    displayName: (res.user.displayName === null ? " " : res.user.displayName),
                    photoURL: (res.user.photoURL === null ? " " : res.user.photoURL)
                };

                if (userRegister.displayName !== null && userRegister.photoURL !== null) setUser(userRegister);
                navigate('/minhas-listas');
            })
            .catch(err => {
                console.error(err);
                setAuthing(false);
            })
    }

    return (
        <>
            <Card style={{ width: '20rem', margin: '0 auto', marginBottom: "3rem", marginTop: "3rem" }}>
                <Card.Body>
                    <Card.Title>Entre com sua conta:</Card.Title>
                    <Form onSubmit={e => {
                        e.preventDefault();
                        handleLogin();
                    }}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Endereço de e-mail:</Form.Label>
                            <Form.Control type="email" placeholder="Digite seu email" onChange={e => setEmail(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Senha</Form.Label>
                            <Form.Control type="password" placeholder="Digite sua senha" onChange={e => setPassword(e.target.value)} />
                        </Form.Group>

                        <Button className="m-3" variant="primary" type="submit">
                            Entrar
                        </Button>
                        <Button className="flex" variant="success" onClick={e => {
                            e.preventDefault();
                            signInWithGoogle();
                        }} disabled={authing}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-google" viewBox="0 0 16 16">
                                <path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z" />
                            </svg>
                            <p>Continuar com o Google</p>
                        </Button> <br/>
                        <br/>
                        <Link to="/register">Ainda não tenho conta</Link>
                    </Form>
                </Card.Body>
            </Card>

        </>
    );

}